import React from 'react';
import { useSelector } from 'react-redux';

import ListingStatsHeader from './ListingStatsHeader';
import ListingSubmissionReviewalHeader from './ListingSubmissionReviewalHeader';
import ListingDraftReviewalHeader from './ListingDraftReviewalHeader';

export default function ListingAdminHeader() {
  const { lifecycle_status, open_drafts } = useSelector((state) => state.listing);

  return (
    <>
      {/* Stats */}
      <ListingStatsHeader />

      {/* Pending listing reviewal */}
      {lifecycle_status === 'submitted' && <ListingSubmissionReviewalHeader />}

      {/* Draft reviewal */}
      {open_drafts && open_drafts.length > 0 && <ListingDraftReviewalHeader />}
    </>
  );
}
